import { DEFAULT_ADULTS_FOR_SEARCH, MIN_ADULTS_FOR_BOATING } from '../../../Constants';
import { convertToDesiredFormat } from '../../../utils/cachedAvail';
import { SUCCESS } from '../../constants';
import { GET_CACHED_AVAIL_DATA } from '../../data/cachedAvail/action-types';
import {
  INCREASE_ADULTS_IF_NONE,
  IS_ARRIVAL_DATE_AVAILABLE,
  RESET_ARRIVAL,
  SELECT_CHANNEL,
  SELECT_DATE,
  SELECT_DURATION,
  SELECT_GUESTS_ADULTS,
  SELECT_GUESTS_CHILDREN,
  SELECT_GUESTS_UNDER5S,
  SELECT_PET_FRIENDLY,
  SELECT_REGION,
  STORE_COTTAGE_DATES,
} from './action-types';

const tomorrow = new Date();
tomorrow.setDate(tomorrow.getDate() + 1);

const initialState = {
  channelId: 'ukcaravan',
  regionId: 'all-regions',
  arrivalDate: tomorrow.toISOString(),
  isArrivalDateAvailable: true,
  duration: 3,
  month: undefined,
  adults: DEFAULT_ADULTS_FOR_SEARCH,
  children: 0,
  under5s: 0,
  petFriendly: false,
  searchNeeded: false,
  partySizeModal: false,
  cottageDates: {},
  isPartyInvalid: false,
  caravanNightsOptions: {},
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SELECT_CHANNEL: {
      const isBoating = action.payload.channelId === 'boats';
      const currentAdults = state.adults;
      const isPartyInvalid = isBoating && currentAdults < MIN_ADULTS_FOR_BOATING;
      return {
        ...state,
        channelId: action.payload.channelId,
        regionId: action.payload.regionId,
        isPartyInvalid,
      };
    }
    case IS_ARRIVAL_DATE_AVAILABLE:
      return {
        ...state,
        isArrivalDateAvailable: action.payload,
      };
    case SELECT_REGION:
      return {
        ...state,
        regionId: action.payload,
      };
    case SELECT_DATE:
      return {
        ...state,
        arrivalDate: action.payload,
      };
    case SELECT_DURATION: {
      return {
        ...state,
        duration: action.payload,
      };
    }
    case INCREASE_ADULTS_IF_NONE:
      return {
        ...state,
        adults: state.adults || DEFAULT_ADULTS_FOR_SEARCH,
      };
    case SELECT_GUESTS_ADULTS: {
      const isBoating = state.channelId === 'boats';
      const newAdults = action.payload;
      const isPartyInvalid = isBoating && newAdults < MIN_ADULTS_FOR_BOATING;
      return {
        ...state,
        adults: action.payload,
        isPartyInvalid,
      };
    }
    case SELECT_GUESTS_CHILDREN:
      return {
        ...state,
        children: action.payload,
      };
    case SELECT_GUESTS_UNDER5S:
      return {
        ...state,
        under5s: action.payload,
      };
    case SELECT_PET_FRIENDLY:
      return {
        ...state,
        petFriendly: action.payload,
      };
    case STORE_COTTAGE_DATES:
      return {
        ...state,
        cottageDates: action.payload,
      };
    case RESET_ARRIVAL:
      return {
        ...state,
        arrivalDate: undefined,
      };
    case GET_CACHED_AVAIL_DATA + SUCCESS: {
      const caravanNightsOptions = createNightsAvailableForEachCaravanRegion(action.payload.response.data.minprices);

      return {
        ...state,
        caravanNightsOptions,
      };
    }
    default:
      return state;
  }
};

export default reducer;

const createNightsAvailableForEachCaravanRegion = (minPrices) => {
  const minPricesData = convertToDesiredFormat(minPrices);

  const caravanNightOptionsPerRegion = Object.fromEntries(
    Object.entries(minPricesData).map(([regionId, pricesArray]) => {
      const uniqueNights = [...new Set(pricesArray.map((item) => item.nights))].sort((a, b) => a - b);
      return [regionId, uniqueNights];
    }),
  );

  // Combine all nights from the per-region lists:
  const uniqueAllNights = [...new Set(Object.values(caravanNightOptionsPerRegion).flat())].sort((a, b) => a - b);

  return {
    ...caravanNightOptionsPerRegion,
    'all-regions': uniqueAllNights,
  };
};
